import { createSelector } from "reselect";
import { AppState } from "../store";
import { ProfileStateI } from "./profileTypes";

const selector = (state: AppState) => state.profileReducer;

export const profileSelector = createSelector([ selector ], (state) => state);

export const updateUserSelector = createSelector(
  [ selector ],
  ({ updateInformationLoading, updateInformationError }: ProfileStateI) => ({
    loading : updateInformationLoading,
    error   : updateInformationError,
  }),
);

export const updateAvatarSelector = createSelector(
  [ selector ],
  ({ updateAvatarLoading, updateAvatarError }: ProfileStateI) => ({
    loading : updateAvatarLoading,
    error   : updateAvatarError,
  }),
);
